import { EnergyPassportDetailsTable } from "@/features/energy-passport/ui/detail-tables/energy-passport-details-table.tsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"

export function EnergyPassportOtherOilProductsTable() {
  // Store
  const { other_oil_product } = useEnergyPassportDetailsStore()

  return <EnergyPassportDetailsTable title="Энергетический баланс других видов нефтепродуктов" storeItem={other_oil_product} />
}
